import { useState, useEffect } from 'react';

export function Header() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 px-6 py-4 bg-[#2196F3] shadow-md transition-all duration-500 ease-in-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full pointer-events-none'
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-start items-center">
        <a href="/" className="flex items-center gap-4 hover:opacity-90 transition-opacity">
          <img 
            src="/roundAsset.png" 
            alt="Locale Logo" 
            className="w-14 h-14 md:w-16 md:h-16"
          />
          <div className="flex flex-col items-start">
            <h1 className="text-2xl md:text-3xl font-bold text-white font-poppins leading-tight text-left">Locale</h1>
            <p className="text-[11px] md:text-[12px] text-blue-50 font-roboto text-left uppercase tracking-wider">Rediscover Community</p>
          </div>
        </a>
      </div>
    </header>
  );
}

